import { useQuery } from "@tanstack/react-query";

import { supabase } from "~/store/initializeStore";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Whether the new address already has a trainee profile. Only then does the e-mail change merge
 * two profiles, and support has to pick which one the client keeps (TRE-2399).
 */
export const useTraineeExistsByEmail = (email: string | undefined) => {
  const normalizedEmail = email?.trim().toLowerCase() ?? "";

  const { data, isFetching } = useQuery({
    queryKey: ["traineeExistsByEmail", normalizedEmail],
    enabled: EMAIL_PATTERN.test(normalizedEmail),
    queryFn: async ({ signal }) => {
      const builder = supabase
        .from("trainee")
        .select("id", { count: "exact", head: true })
        .eq("email", normalizedEmail);
      const { count, error } = await (signal ? builder.abortSignal(signal) : builder);

      if (error) {
        throw new Error(error.message);
      }

      return (count ?? 0) > 0;
    },
  });

  return { exists: data ?? false, isFetching };
};
